import { graphql } from './chunk-NWN55YVG.mjs';

// src/listen/query-hooks/fragments.ts
var AudioFragment = graphql(
  /* GraphQL */
  `
  fragment AudioFields on audios {
    id
    name
    source
    thumbnailUrl
    artistName
  }
`
);
var PlaylistAudioFragment = graphql(
  /* GraphQL */
  `
  fragment PlaylistAudioFields on playlist_audios {
    position
    audio {
      ...AudioFields
    }
  }
`
);
var PlaylistFragment = graphql(
  /* GraphQL */
  `
  fragment ListenPlaylistFields on playlist {
    id
    title
    thumbnailUrl
    slug
    createdAt
    description
    playlist_audios(order_by: { position: asc }) {
      ...PlaylistAudioFields
    }
  }
`
);

export { AudioFragment, PlaylistAudioFragment, PlaylistFragment };
//# sourceMappingURL=chunk-IQYQ7RE4.mjs.map
//# sourceMappingURL=chunk-IQYQ7RE4.mjs.map